export default "__VITE_ASSET__1aa4c469__"